import { Injectable } from '@angular/core';
import { ExpandableRowsService } from './expandable-rows.service';

@Injectable()
export class ExpandableRowsServiceFactory {
    public create<T = object>(): ExpandableRowsService<T> {
        return new ExpandableRowsService<T>();
    }
}
